import { useState } from 'react'
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc'
import Chip, { chipType } from '../chip/chip'
import ImageModal from '../imageModal/imageModal'
import ProgressiveImage from '../progressiveImage/ProgressiveImage'

import './projectCard.scss'

type ProjectCardProps = {
  title: string
  description: string
  fromTo: string
  images: string[]
  imageThumbnails?: string[]
  technologies: Array<chipType>
  url?: string
  largeImage?: string
  largeImageThumbnail?: string
}

function ProjectCard(props: Readonly<ProjectCardProps>) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % props.images.length)
  }

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + props.images.length) % props.images.length)
  }

  const handleCardClick = () => {
    if (props.url) {
      window.open(props.url, '_blank', 'noopener,noreferrer')
    } else if (props.largeImage) {
      setIsModalOpen(true)
    }
  }

  const hasMultipleImages = props.images.length > 1

  return (
    <>
      <ImageModal
        isOpen={isModalOpen}
        imageSrc={props.largeImage || ''}
        imageAlt={`${props.title} - Large view`}
        onClose={() => setIsModalOpen(false)}
        imageThumbnail={props.largeImageThumbnail}
      />
      <div
        className={`comp-projectCard ${props.url || props.largeImage ? 'comp-projectCard-clickable' : ''}`}
        onClick={handleCardClick}
      >
      <div className='projectCard-imageSection'>
        <div className='imageSection-container'>
          {props.images.length > 0 && (
            <>
              <ProgressiveImage
                src={props.images[currentImageIndex]}
                thumbnail={props.imageThumbnails?.[currentImageIndex] || ''}
                alt={`${props.title} - Screenshot ${currentImageIndex + 1}`}
                className='projectCard-image'
              />
              {hasMultipleImages && (
                <>
                  <button className='imageNav imageNav-left' onClick={(e) => { e.stopPropagation(); prevImage(); }}>
                    <VscChevronLeft />
                  </button>
                  <button className='imageNav imageNav-right' onClick={(e) => { e.stopPropagation(); nextImage(); }}>
                    <VscChevronRight />
                  </button>
                  <div className='imageSection-dots'>
                    {props.images.map((_, index) => (
                      <div
                        key={index}
                        className={`dot ${index === currentImageIndex ? 'dot-active' : ''}`}
                        onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div className='projectCard-content'>
        <div className='content-header'>
          <div className='header-title'>{props.title}</div>
          <div className='header-time'>{props.fromTo}</div>
        </div>

        <div className='content-description'>{props.description}</div>

        {props.url && (
          <div className='content-url'>
            {props.url}
          </div>
        )}

        <div className='content-technologies'>
          {props.technologies.map((tech) => (
            <Chip key={tech} type={tech} />
          ))}
        </div>
      </div>

      <div className='projectCard-bottom'>
        <div className='bottom-bar' />
      </div>
    </div>
    </>
  )
}

export default ProjectCard
